import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ActiveToast, IndividualConfig, ToastrService } from 'ngx-toastr';

@Injectable({
    providedIn: 'root',
})
export class TranslatedToastrService {
    constructor(
        private toastrService: ToastrService,
        private translateService: TranslateService
    ) {}

    public info<ConfigPayload = any>(
        message: string,
        title?: string,
        override?: Partial<IndividualConfig<ConfigPayload>>,
        additionalInformation?: string
    ): ActiveToast<any> {
        return this.toastrService.info(
            this.getFullMessage(message, additionalInformation),
            this.translateService.instant(title ? title : ''),
            override
        );
    }

    public success<ConfigPayload = any>(
        message: string,
        title?: string,
        override?: Partial<IndividualConfig<ConfigPayload>>,
        additionalInformation?: string
    ): ActiveToast<any> {
        return this.toastrService.success(
            this.getFullMessage(message, additionalInformation),
            this.translateService.instant(title ? title : ''),
            override
        );
    }

    public warning<ConfigPayload = any>(
        message: string,
        title?: string,
        override?: Partial<IndividualConfig<ConfigPayload>>,
        additionalInformation?: string
    ): ActiveToast<any> {
        const fullMessage = `${this.getFullMessage(message, additionalInformation)}<br>${new Date()}`;

        return this.toastrService.warning(fullMessage, this.translateService.instant(title ? title : ''), {
            ...override,
            enableHtml: true,
        });
    }

    public error<ConfigPayload = any>(
        message: string,
        title?: string,
        override: Partial<IndividualConfig<ConfigPayload>> = {},
        additionalInformation?: string
    ): ActiveToast<any> {
        override.timeOut = 20000;
        const fullMessage = `${this.getFullMessage(message, additionalInformation)}<br>${new Date()}`;

        return this.toastrService.error(fullMessage, this.translateService.instant(title ? title : ''), {
            ...override,
            enableHtml: true,
        });
    }

    private getFullMessage(message: string, additionalInformation?: string): string {
        let extraMessage = '';
        if (additionalInformation) {
            extraMessage = ' ' + additionalInformation;
        }
        return this.translateService.instant(message ? message : '') + extraMessage;
    }
}
